RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Message = Backbone.Model.extend({
        defaults: {
            type: 'info',
            closeable: true,
            upsell: true,
            img: '/images/sad_graphs.png',
            title: null,
            description: null,
            actions: null
        }
    });

    function getStateModel(propable) {
        let state;
        const stateProperty = propable.getProp('state');
        if (stateProperty) {
            state = RivalIQ.state[stateProperty];
        }
        return state;
    }

    const Limitation = Marionette.ItemView.mixin({

        template: '#widgetsDashboardLimitationTemplate',

        ui: {
            contactUsBtn: '.x-contact-us'
        },

        behaviors: {
            Dismissible: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        events: {
            'click @ui.contactUsBtn': 'onContactUsClick',
            // NOTE do not replace with triggers hash!
            // The default parameter passed to 'onWidgetDismissed' results in
            // serialization of a cyclic structure.
            'click .dismiss': 'onDismissClick'
        },

        className: function () {
            const me = this;
            return _.compact([
                'widget-limitation',
                'callout',
                'text-center',
                'x-export-hide',
                ['callout', me.getProp('type')].join('-'),
                me.getProp('className')
            ]).join(' ');
        },

        onContactUsClick: function () {
            const me = this;
            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: me.model.get('context')
                })
            }));
        },

        onDismissClick: function () {
            const me = this;
            me.dashboardModel.dismiss(null, getStateModel(me));
        },

        initialize: function () {
            const me = this;
            me.model = new Message(me.getProps());
        }
    });

    const LimitationWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        viewMore: false,
        panelView: Limitation,
        filter: function () {
            const me = this;
            return me.isDismissed({
                state: getStateModel(me)
            });
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.LIMITATION, LimitationWidget);
});
